import React, { useEffect, useState } from 'react';

export default function RoleModal({ open, mode = 'new', data = null, onClose, onSubmit, inline = false }) {
  const [form, setForm] = useState({
    idRol: 0,
    nombre: '',
    descripcion: '',
  });

  useEffect(() => {
    if (mode === 'edit' && data) {
      setForm({
        idRol: data.idRol,
        nombre: data.nombre || '',
        descripcion: data.descripcion || '',
      });
    } else {
      setForm({ idRol: 0, nombre: '', descripcion: '' });
    }
  }, [mode, data]);

  if (!open) return null;

  const Content = (
    <>
      <div className="roles-topbar" style={{ marginBottom: '0.6rem' }}>
        <h3 className="roles-title" style={{ marginRight: 0 }}>
          {mode === 'new' ? 'Nuevo rol' : 'Editar rol'}
        </h3>
        <button className="roles-btn" onClick={onClose} aria-label="Cerrar">✕</button>
      </div>

      {/* Stacked, descripción arriba */}
      <div style={{ display: 'grid', gridTemplateColumns: '1fr', gap: '0.8rem' }}>
        <div>
          <label className="roles-title" style={{ fontSize: '.95rem' }}>Nombre:</label>
          <input
            className="roles-search"
            value={form.nombre}
            onChange={(e) => setForm({ ...form, nombre: e.target.value })}
            placeholder="Nombre del rol"
            maxLength={100}
          />
        </div>

        <div>
          <label className="roles-title" style={{ fontSize: '.95rem' }}>Descripción:</label>
          <textarea
            className="roles-search"
            style={{ minHeight: 100, resize: 'vertical' }}
            value={form.descripcion || ''}
            onChange={(e) => setForm({ ...form, descripcion: e.target.value })}
            placeholder="Describe el alcance del rol"
            maxLength={250}
          />
        </div>
      </div>

      <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '.6rem', marginTop: '.8rem' }}>
        <button className="btn-cancel" onClick={onClose}>Cancelar</button>
        <button
          className="btn-action"
          onClick={() => onSubmit(form, mode)}
          disabled={!form.nombre?.trim()}
        >
          {mode === 'new' ? 'Guardar' : 'Actualizar'}
        </button>
      </div>
    </>
  );

  if (inline) {
    return <div className="roles-inline-card">{Content}</div>;
  }

  return (
    <div className="roles-confirm-overlay" role="dialog" aria-modal="true" aria-label="Role modal">
      <div className="roles-confirm-card" style={{ width: 'min(980px,96vw)' }}>
        {Content}
      </div>
    </div>
  );
}
